import BackboneElement from './BackboneElement';
import Reference from './types/Reference';
import merge from 'lodash/merge';

export default class Reconciliation extends BackboneElement {
    static __className = 'Reconciliation';

    __objectStructure = {
        date: String,
        practitioner: Reference,
        encounter: Reference,
    };

    constructor(constructJson, className = 'Reconciliation') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
